import { ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUpdateUserMutation } from '../../common/hooks/backend';
import { useAppDispatch } from '../../store';
import { Platform } from '../enums/platform.enum';
import { useFeatureFlagPlatform } from '../featureFlags/hooks';
import { setCurrentPlatform } from './platformSlice';
import { getPlatformFromLocation } from './utils';

interface PlatformProviderProps {
  children: React.ReactNode;
}

function PlatformProvider({ children }: PlatformProviderProps): ReactElement {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const [updateUserMutation] = useUpdateUserMutation();
  const asqEnabled = useFeatureFlagPlatform(Platform.ASQ);
  const currentUrlPlatform = getPlatformFromLocation(pathname);

  useEffect(() => {
    if (asqEnabled) dispatch(setCurrentPlatform(getPlatformFromLocation(pathname)));
  }, [pathname, dispatch, asqEnabled]);

  useEffect(() => {
    if (currentUrlPlatform === Platform.ASQ) {
      updateUserMutation({ UpdateASQLastLogin: true }).catch((err) => {
        console.error(err);
      });
    }
  }, [currentUrlPlatform, updateUserMutation]);

  return <>{children}</>;
}

export { PlatformProvider };
